import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import Layout from './components/Layout.vue';
import Global from './components/Global.vue';
import axios from 'axios';
import md5  from 'js-md5';


Vue.use(ElementUI);
Vue.prototype.Global = Global;

 Vue.prototype.$axios=axios;

Vue.prototype.getSessionStorage=function(item){
  return sessionStorage.getItem(item);
}
Vue.prototype.setSessionStorage=function(item,val){
  return sessionStorage.setItem(item,val);
}
Vue.prototype.removeSessionStorage=function(item){
  return sessionStorage.removeItem(item);
}
Vue.prototype.getLocalStorage=function(item){
  return localStorage.getItem(item);
}
Vue.prototype.setLocalStorage=function(item,val){
  return localStorage.setItem(item,val);
}
Vue.prototype.removeLocalStorage=function(item){
  return localStorage.removeItem(item);
}

Vue.prototype.getToken=function(){
  const secret = 'cf469a868f32874749decf213f5987';
  var uid = this.getLocalStorage('uid') || '';
  var timespan = getTimestampInSeconds();
  var map = new Map();
  map.set('uid',uid);
  map.set('timespan',timespan);
  map.set('secret',secret);
  
  // 获取Map中的所有键，并转换为数组
  var keys = Array.from(map.keys());

  // 对键数组进行排序（升序）
  keys.sort();
  //按照规则进行拼接
  var sortStr='';
  keys.forEach(function(key) {
    if (sortStr.length>0){
      sortStr = sortStr + '&';
    }
   var item = key+'='+map.get(key);
   sortStr = sortStr + item;
  });

  //console.log('sortstr:'+sortStr);
  var sign = md5(sortStr);
  var o = {};
  o.uid = uid;
  o.timespan = timespan;
  o.sign = sign;
  return o;
}

function getTimestampInSeconds(dateTime) {
  // 确保输入的日期是 UTC 时间
  var utcDateTime = dateTime || new Date().toUTCString();
  var date = new Date(utcDateTime);
  date.setMilliseconds(0); // 确保没有毫秒部分
  var timestamp = Math.floor(date.getTime() / 1000);
  return timestamp;
}

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
